import { Stack, Typography } from '@mui/material';

import { Icon } from './icon';

export const CounterStrip = ({
  label,
  count,
  hideSubdirectoryIcon,
}: {
  label: string;
  count: number;
  hideSubdirectoryIcon?: boolean;
}) => {
  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Stack direction='row' alignItems='center' gap='8px'>
        {!hideSubdirectoryIcon && (
          <Icon iconClass='material-symbols-subdirectory-arrow-right-rounded' />
        )}
        <Typography variant='subtitle1'>{label}</Typography>
      </Stack>
      <Typography variant='subtitle1'>{count}</Typography>
    </Stack>
  );
};
